import { Component } from "@angular/core";

@Component({
  selector: "app-privacy-policy-etx",
  templateUrl: "./privacy-policy-etx.component.html",
  styleUrls: ["./privacy-policy-etx.component.scss"],
  standalone: false
})
export class PrivacyPolicyEtxComponent {}
